const Login = () => import('./Login.vue')
const Layout = () => import('../../external/Layout.vue')
const Register = () => import('./Register.vue')
const ForgotPassword = () => import('./ForgotPassword.vue')
const RegisterClientLink = () => import('./RegisterClientLink.vue')
// const RegisterStepTwo = () => import("./RegisterStepTwo.vue");
// const ResetPassword = () => import("./ResetPassword.vue");
// const NewPassword = () => import("./NewPassword.vue");

const AuthRoutes = {
  component: Layout,
  children: [
    {
      path: '',
      name: 'LoginClient',
      component: Login,
      props: true,
      meta: {
        requiresAuth: false,
        requiresAdmin: false,
      },
    },
    {
      path: 'register-client',
      name: 'RegisterClient',
      component: Register,
      meta: {
        requiresAuth: false,
        requiresAdmin: false,
      },
    },
    {
      path: 'register-client-link',
      name: 'RegisterClientLink',
      component: RegisterClientLink,
      meta: {
        requiresAuth: false,
        requiresAdmin: false,
      },
    },
    {
      path: 'forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        requiresAdmin: false,
      },
    },
    // {
    //   path: "register-client-step-two",
    //   name: "RegisterClientStepTwo",
    //   component: RegisterStepTwo,
    //   meta: {
    //     requiresAuth: false,
    //     requiresAdmin: false,
    //   },
    // },
    // {
    //   path: "forgot-password",
    //   name: "ForgotPasswordClient",
    //   component: ResetPassword,
    //   meta: {
    //     requiresAuth: false,
    //     requiresAdmin: false,
    //   },
    // },
    // {
    //   path: "new-password/:user_id/:pin",
    //   name: "NewPasswordClient",
    //   component: NewPassword,
    //   meta: {
    //     requiresAuth: false,
    //     requiresAdmin: false,
    //   },
    // },
    { path: '*', redirect: '/auth' },
  ],
}

export default AuthRoutes
